module.exports = __webpack_public_path__ + "static/img/4_1_3.e8be1d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/4_1_3.png
// module id = vm4x
// module chunks = 1